export const FIREBASE_API_KEY = "AIzaSyCgEzt0Luo9NkHtVJWj4WwUx2DrRHsgLGk"
export const FIREBASE_AUTH_DOMAIN = "miabc-a2e3a.firebaseapp.com"
export const FIREBASE_DATABASE_URL = "https://miabc-a2e3a.firebaseio.com"
export const FIREBASE_PROJECT_ID = "miabc-a2e3a"
export const FIREBASE_STORAGE_BUCKET = "miabc-a2e3a.appspot.com"
export const FIREBASE_MESSAGING_SENDER_ID = "623859773179"
export const FIREBASE_APP_ID = "1:623859773179:web:d5735d1d1bc2b0cfdf8a5e"
export const MEASUREMENT_ID = "G-7ZB8WQ370Z"
